export default __webpack_public_path__ + "static/media/printerIcon.7c676479.svg";